import getInstanceAxios from "../Request";

const baseDomain = process.env.REACT_APP_BASE_CAMPAIGN_API_URL;
const baseURL = `${baseDomain}/`;
export default getInstanceAxios(baseURL);
